import { useState, useEffect } from "react";
import { Client, getAllClientsList } from "../../apis/tenantApi/tenantApi";
import SubHeader from "../../layouts/subheader/SubHeader";
import { Container, CircularProgress } from '@mui/material';
// import TenantList from "../../components/Report/ReportsList";
import ReportsList from "../../components/Report/ReportsList";

interface ListProps {
  onOpenReports?: (t: Client) => void;
}
const List: React.FC<ListProps> = ({ onOpenReports }) => {
    const [tenants, setTenants] = useState<Client[]>([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
    const fetchTenants = async () => {
      try {
        const fetchedTenants = await getAllClientsList();
        if (Array.isArray(fetchedTenants)) {
          console.log(fetchedTenants)
          setTenants(fetchedTenants);
        } else {
          console.error("Unexpected response format:", fetchedTenants);
          setTenants([]);
        }
      } catch (error) {
        console.error("Error fetching tenants:", error);
        setTenants([]);
      } finally {
        setIsLoading(false);
      }
    };
    fetchTenants();
  }, []);

  return (
<div className="tab-page-layout-1">
  <SubHeader title="All Tenants" />
  {isLoading ? (
    <Container maxWidth="sm" sx={{ textAlign: 'center', marginTop: '100px' }}>
      <CircularProgress />
      <div>Loading data...</div>
    </Container>
  ) : (
    <>
    <ReportsList tenants={tenants} onOpenReports={onOpenReports}/>
    </>
  )}
</div>
  );
};
export default List;